import { focusRing } from '@/lib/styleUtils';

/** Dropdown container — positioned fixed, right-aligned below avatar.
 *  16px corner radius + 24px content gutter (via the sections) to match Figma
 *  node 8845:64396. */
export const dropdownContainerClasses = [
  'tw:bg-white',
  'tw:border tw:border-solid tw:border-gray-light',
  'tw:rounded-16',
  'tw:shadow-[0px_2px_5px_0px_rgba(76,89,107,0.1)]',
  'tw:flex tw:flex-col',
  'tw:py-base',
  'tw:w-[340px]',
  'tw:z-50',
].join(' ');

/** "Actions" section — profile row + QR cards, closed by a bottom divider. */
export const userSectionClasses = [
  'tw:flex tw:flex-col tw:gap-base',
  'tw:border-b tw:border-solid tw:border-gray-light',
  'tw:pb-base',
].join(' ');

/** Profile row — 48px avatar + name/email + chevron, with its own bottom divider.
 *  24px horizontal gutter (px-huge) shared with the QR cards below. */
export const userRowClasses = [
  focusRing,
  'tw:flex tw:items-center tw:gap-small',
  'tw:pt-small tw:pb-base tw:px-huge',
  'tw:border-x-0 tw:border-t-0 tw:border-b tw:border-solid tw:border-gray-light',
  'tw:cursor-pointer',
  'tw:bg-transparent',
  'tw:w-full tw:text-left',
].join(' ');

/** Name — 24px bold (fontSize-5). */
export const userNameClasses = 'tw:text-24 tw:font-bold tw:text-font tw:tracking-[0.3px] tw:truncate';

/** Email — 14px gray-darker under the name. */
export const userEmailClasses = 'tw:text-14 tw:text-gray-darker tw:leading-[18px] tw:truncate';

/** Action cards container (vertical stack) — 24px gutter (px-huge). */
export const actionCardsContainerClasses = [
  'tw:flex tw:flex-col tw:gap-small',
  'tw:px-huge',
].join(' ');

/** Individual action card (horizontal: leading icon, text, trailing QR icon) */
export const actionCardClasses = [
  focusRing,
  'tw:w-full',
  'tw:flex tw:items-center tw:gap-small',
  'tw:bg-white',
  'tw:border tw:border-solid tw:border-gray-light',
  'tw:rounded-8',
  'tw:px-base tw:py-base',
  'tw:cursor-pointer',
  'tw:text-left',
].join(' ');

export const actionCardTitleClasses = 'tw:text-16 tw:text-font tw:leading-[20px]';

export const actionCardSubtitleClasses = 'tw:text-14 tw:text-gray-dark tw:leading-[18px]';

export const actionCardIconClasses = 'tw:text-gray-darker tw:text-[24px] tw:shrink-0';

/** Trailing QR / scan glyph on the right of each action card. */
export const actionCardTrailingIconClasses = 'tw:text-gray-darker tw:text-[20px] tw:shrink-0';

/** Menu items section — 8px section gutter + 16px cell gutter = 24px, matching the cards. */
export const menuSectionClasses = 'tw:flex tw:flex-col tw:pt-micro tw:px-micro';

/** Menu item row — leading icon + label (no trailing chevron), per Figma. */
export const menuItemClasses = [
  focusRing,
  'tw:flex tw:items-center tw:gap-micro',
  'tw:px-base tw:py-small',
  'tw:cursor-pointer',
  'tw:rounded-8',
  'tw:text-16 tw:text-font',
  'tw:bg-transparent tw:border-0',
  'tw:w-full tw:text-left',
].join(' ');

/** Leading icon on a menu item. */
export const menuItemIconClasses = 'tw:text-gray-darker tw:text-[16px] tw:shrink-0';

export const chevronClasses = 'tw:text-gray-dark tw:shrink-0 tw:text-[16px]';

/** Invisible overlay for click-outside */
export const overlayClasses = 'tw:fixed tw:inset-0 tw:z-40';
